import { Fragment } from "react";
import { Nav } from "react-bootstrap";
import { NavLink, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export default function NavbarTransferencias() {
    const user = useSelector(state => state.userSlice)
    return (
        <Fragment>
            <Nav variant='tabs'>
                {
                    user.tipo.toLowerCase() === 'empresa' || user.tipo.toLowerCase() === 'gestor' ?
                        <Fragment>
                            <Nav.Item>
                                <NavLink className="nav-link" to='relatorio'>Relatorio</NavLink>
                            </Nav.Item>
                            <Nav.Item>
                                <NavLink className="nav-link" to='finalizados'>Finalizado</NavLink>
                            </Nav.Item>
                            <Nav.Item>
                                <NavLink className="nav-link" to='lancamentos'>Emissões</NavLink>
                            </Nav.Item>
                        </Fragment>
                        :
                        ""
                }
                {
                    user.tipo.toLowerCase() === 'empresa' || user.id_filial == '2' ? 
                        <Fragment>
                            <Nav.Item>
                                <NavLink className="nav-link" to='emissao'>Cadastrar</NavLink>
                            </Nav.Item>
                        </Fragment>
                        :
                        ""
                }
            </Nav>
            <Outlet />
        </Fragment>
    )
}






